<template>
  <div>
    <div class="loading-data-wrapper" style="position: fixed" v-if="disableAPI">
      <div class="loading-data">
        <div></div><div></div><div></div>
      </div>
    </div>
    <div v-if="registrationForm.registrationFormSubmitted && !registrationForm.registrationErrors">
      <div class="forgot-password">
        <div class="landing-page-wrapper">
          <div class="landing-page-content">
            <div class="forgot-password custom-response" :class="'custom-response-' + registrationForm.registrationFormResponseCode">
              <h1 class="page-title color-1-100 text-left">
                <span class="page-title-icon">
                  <template v-if="registrationForm.registrationFormResponseCode === 1 ||
                                  registrationForm.registrationFormResponseCode === 2 ||
                                  registrationForm.registrationFormResponseCode === 3 ||
                                  registrationForm.registrationFormResponseCode === 4 ||
                                  registrationForm.registrationFormResponseCode === 5 ||
                                  registrationForm.registrationFormResponseCode === 6 ||
                                  registrationForm.registrationFormResponseCode === 7 ||
                                  registrationForm.registrationFormResponseCode === 8">
                    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                         viewBox="0 0 15.002 15.002" style="enable-background:new 0 0 15.002 15.002;" xml:space="preserve">
                      <polygon id="XMLID_2_" class="st0" points="7.501,9.794 2.293,15.002 0,12.709 5.208,7.501 0,2.293 2.293,0.001 7.501,5.208
                        12.709,0 15.002,2.293 9.794,7.501 15.002,12.709 12.709,15.002 "/>
                    </svg>
                  </template>
                  <template v-else>
                    <svg version="1.1" id="icons" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                         viewBox="0 0 12.163 9.729" style="enable-background:new 0 0 12.163 9.729;" xml:space="preserve">
                        <polygon class="st0" points="10.394,0 4.841,6.109 1.768,3.035 0,4.804 4.927,9.729 12.163,1.77 "/>
                    </svg>
                  </template>
                </span>
                <template v-if="registrationForm.registrationFormResponseCode === 7">
                  Your email domain is not in the list of approved domains for this company
                </template>
                <template v-else-if="registrationForm.registrationFormResponseCode === 8">
                  Your email domain is not in the list of approved domains for this company
                </template>
                <template v-else-if="registrationForm.registrationFormResponseCode === 9">
                  Your request was successfully sent
                </template>
                <template v-else-if="registrationForm.registrationFormResponseCode === 10">
                  Your account was successfully created.
                </template>
              </h1>
              <p class="page-description color-2-77 text-left">
                <template v-if="registrationForm.registrationFormResponseCode === 7">
                  Use your work email if you want your account to be automatically activated. Alternatively,
                  you can submit your request and wait until it's manually approved by a company administrator.
                </template>
                <template v-else-if="registrationForm.registrationFormResponseCode === 8">
                  You need to use your work email to create an account.
                </template>
                <template v-else-if="registrationForm.registrationFormResponseCode === 9">
                  We'll send you an email with credentials and login instructions you as soon as your request
                  is approved by a company administrator.
                </template>
                <template v-else-if="registrationForm.registrationFormResponseCode === 10">
                  We've sent you an email with your temporary credentials.<br /><br />
                  Please be patient, it make take a few minutes before the email arrives in your inbox.
                  If it doesn't, please look for it in the spam or junk folder as well.
                </template>
              </p>
              <div class="landing-page-login-info"
                   v-if="registrationForm.registrationFormResponseCode === 9 || registrationForm.registrationFormResponseCode === 10">
                Have a question? <router-link :to="{ name: 'contact' }">Send us your message here</router-link>.
              </div>
              <div class="landing-page-login-info-buttons" v-else>
                <button @click.prevent.stop="changeEmail()" class="background-1-10 background-1-50-hover color-2-100">
                  Change email
                </button>
                <button @click.prevent.stop="submitForm(true)"
                        v-if="registrationForm.registrationFormResponseCode === 7"
                        class="color-2-100 border-1-50">
                  Submit request
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="homepage company-landing" v-if="!registrationForm.registrationFormSubmitted">
      <div class="landing-page-edit-panel"
           v-if="isGM()">
        <div class="wrapper" :class="[{ 'active': landingPanel }]">
          <div class="landing-page-edit-settings" @click.prevent="landingPanel = !landingPanel"></div>
          <div v-if="editHistory === false">
            <div class="action-btn"
                 @click.prevent="pageMetaEdit = true">Edit page meta</div>
            <div class="action-btn"
                 v-if="pageEditMode === false"
                 @click.prevent="pageEditSwitch()">Edit page content</div>
            <div class="action-btn"
                 v-if="pageEditMode === false"
                 @click.prevent="footerEdit = true">Edit page footer logos</div>
            <div class="action-btn"
                 @click.prevent="editPageLogo()">Edit page logo</div>
            <div class="action-btn"
                 @click.prevent="activateEditHistory()">Page edit history</div>
          </div>
          <div v-if="editHistory === true">
            <div class="form-group">
              <div class="form-element">
                <label for="page-versions" class="form-label color-2-63">Page save history</label>
                <v-select class="form-control form-control__select"
                          :searchable = false
                          @input="changeLandingPage($event)"
                          :options="getPageVersionsForSelect()"
                          data-lpignore="true"
                          id="page-versions" />
              </div>
            </div>
          </div>
          <div class="action-btn-bottom">
            <div class="action-btn action-btn-save"
                 v-if="pageEditMode === true"
                 @click.prevent="updateLandingPage()">Save</div>
            <div class="action-btn action-btn-discard"
                 @click.prevent="discardPageEdit()">Discard</div>
          </div>
        </div>
      </div>
      <div class="landing-page-wrapper hero-section"
           v-show="!content.heroSection.hideSection || content.heroSection.hideSection === 'null' || (pageEditMode && isGM())">
        <div class="landing-page-content">
          <div class="toggle-section-visibility"
               v-if="pageEditMode && isGM()">
            <input type="checkbox"
                   class="form-control__checkbox"
                   id="showHero"
                   v-model="content.heroSection.hideSection" />
            <label :for="'showHero'">Hide this section</label>
          </div>
          <div class="flex-section">
            <div class="left-content">
              <div class="hero-title">
              <span class="content color-2-100"
                    v-html="content.heroSection.title"
                    v-if="!pageEditMode">
              </span>
                <textarea class="content color-2-100"
                          v-if="pageEditMode && isGM()"
                          data-gramm_editor="false"
                          placeholder="Section title"
                          data-lpignore="true"
                          rows="1"
                          v-model="content.heroSection.title"
                          v-on:keydown="autoSize($event)">{{ content.heroSection.title }}</textarea>
              </div>
              <div class="hero-pwd">
                <div class="hero-pwd-text">
                  Powered by
                </div>
                <div class="hero-pwd-logo">
                  <img v-if="selectedHightCont != 1" src="../../assets/img/svg/logo.svg" alt=" " />
                  <img v-else src="../../assets/img/svg/high-contrast/logo-yellow.svg" alt=" " />
                </div>
              </div>
              <div class="hero-description">
              <span class="content"
                    v-html="content.heroSection.description"
                    v-if="!pageEditMode">
              </span>
                <textarea class="content"
                          v-if="pageEditMode && isGM()"
                          data-gramm_editor="false"
                          placeholder="Section title"
                          data-lpignore="true"
                          rows="1"
                          v-model="content.heroSection.description"
                          v-on:keydown="autoSize($event)">{{ content.heroSection.description }}</textarea>
              </div>
              <div class="hero-login registration-form">
                <form @submit.prevent="submitForm(false)">
                  <div class="landing-page-login-wrapper">
                    <div class="landing-page-login-group"
                         :class="[{ 'active': registrationForm.firstName !== '' || focus === 'firstName', 'has-error': errors.has('First name') }]">
                      <label for="firstName">First name</label>
                      <input id="firstName"
                             :class="[{ 'border-1-20': registrationForm.firstName !== '' || focus === 'firstName' }]"
                             type="text"
                             v-validate="'required'"
                             data-vv-name="First name"
                             @focus="focus = 'firstName'"
                             @blur="focus = null"
                             v-model="registrationForm.firstName" />
                      <span class="form-field-error" v-if="this.errors.has('First name')">{{ this.errors.first('First name') }}</span>
                    </div>
                    <div class="landing-page-login-group"
                         :class="[{ 'active': registrationForm.lastName !== '' || focus === 'lastName', 'has-error': errors.has('Last name') }]">
                      <label for="lastName">Last name</label>
                      <input id="lastName"
                             :class="[{ 'border-1-20': registrationForm.lastName !== '' || focus === 'lastName' }]"
                             type="text"
                             v-validate="'required'"
                             data-vv-name="Last name"
                             @focus="focus = 'lastName'"
                             @blur="focus = null"
                             v-model="registrationForm.lastName" />
                      <span class="form-field-error" v-if="this.errors.has('Last name')">{{ this.errors.first('Last name') }}</span>
                    </div>
                    <div class="landing-page-login-group"
                         :class="[{ 'active': registrationForm.email !== '' || focus === 'email', 'has-error': errors.has('Email address') }]">
                      <label for="email">Email address</label>
                      <input id="email"
                             :class="[{ 'border-1-20': registrationForm.email !== '' || focus === 'email' }]"
                             type="email"
                             v-validate="'required|email'"
                             data-vv-name="Email address"
                             @focus="focus = 'email'"
                             @blur="focus = null"
                             v-model="registrationForm.email" />
                      <span class="form-field-error" v-if="this.errors.has('Email address')">{{ this.errors.first('Email address') }}</span>
                    </div>
                    <div class="landing-page-login-group"
                         :class="[{ 'active': registrationForm.phone !== '' || focus === 'phone', 'has-error': errors.has('Phone number') }]">
                      <label for="phone">Phone number</label>
                      <input id="phone"
                             :class="[{ 'border-1-20': registrationForm.phone !== '' || focus === 'phone' }]"
                             type="text"
                             v-validate="'required'"
                             data-vv-name="Phone number"
                             @focus="focus = 'phone'"
                             @blur="focus = null"
                             v-model="registrationForm.phone" />
                      <span class="form-field-error" v-if="this.errors.has('Phone number')">{{ this.errors.first('Phone number') }}</span>
                    </div>
                    <div class="landing-page-login-group"
                         :class="[{ 'active': registrationForm.function !== '' || focus === 'function', 'has-error': errors.has('Function') }]">
                      <label for="function">Function</label>
                      <input id="function"
                             :class="[{ 'border-1-20': registrationForm.function !== '' || focus === 'function' }]"
                             type="text"
                             v-validate="'required'"
                             data-vv-name="Function"
                             @focus="focus = 'function'"
                             @blur="focus = null"
                             v-model="registrationForm.function" />
                      <span class="form-field-error" v-if="this.errors.has('Function')">{{ this.errors.first('Function') }}</span>
                    </div>
                    <div class="landing-page-login-group"
                         :class="[{ 'active': registrationForm.title !== '' || focus === 'title', 'has-error': errors.has('Title') }]">
                      <label for="title">Title</label>
                      <input id="title"
                             :class="[{ 'border-1-20': registrationForm.title !== '' || focus === 'title' }]"
                             type="text"
                             v-validate="'required'"
                             data-vv-name="Title"
                             @focus="focus = 'title'"
                             @blur="focus = null"
                             v-model="registrationForm.title" />
                      <span class="form-field-error" v-if="this.errors.has('Title')">{{ this.errors.first('Title') }}</span>
                    </div>
                    <div class="login-form-error" v-if="registrationForm.registrationErrors">
                      <ul class="error-list" v-for="error of registrationForm.registrationErrors">
                        <li>{{ error }}</li>
                      </ul>
                    </div>
                    <div class="landing-page-login-actions">
                      <button class="register background-1-10 background-1-50-hover color-2-100"
                              type="submit"
                              :class="[{ 'active-logging': registrationForm.registrationInProgress }]">Submit data</button>
                    </div>
                  </div>
                </form>
                <div class="registration-form-info">
                  <p>Fields marked with an asterisk (<span>*</span>) are mandatory.</p>
                  <p>
                    <strong>Privacy:</strong> Your details will be used to keep you informed about resources provided by The Clear Company.
                    <router-link :to="{ name: 'privacy-policy' }">Click here</router-link> to find out more about the services we provide.
                  </p>
                  <div class="have-account">
                    <span>Already have an account?</span>
                    <router-link :to="{ 'name': 'company-landing', 'params': { 'id': industryLanding } }">
                      Log in here
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
            <div class="right-content">
              <div class="hero-image">
                <div class="content"
                     :title="content.heroSection.altImage"
                     v-bind:style="{ backgroundImage: getImage(content.heroSection.image) }">
                  <input type="text"
                         placeholder="Alt image"
                         v-if="pageEditMode && isGM()"
                         class="landing-page-image-alt"
                         v-model="content.heroSection.altImage" />
                  <label :for="'hero-image-upload'"
                         v-if="pageEditMode && isGM()"
                         class="hero-upload"></label>
                  <input type="file"
                         v-if="pageEditMode && isGM()"
                         @change="onFileChange($event, content.heroSection, 'image')"
                         :id="'hero-image-upload'" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="landing-page-wrapper login-steps landing-page-wrapper-gray"
           v-show="!content.stepSection.hideSection || content.stepSection.hideSection === 'null' || (pageEditMode && isGM())">
        <div class="landing-page-shadow"></div>
        <div class="landing-page-content background-1-100-before">
          <div class="toggle-section-visibility"
               style="top: 20px;"
               v-if="pageEditMode && isGM()">
            <input type="checkbox"
                   class="form-control__checkbox"
                   id="showStep"
                   v-model="content.stepSection.hideSection" />
            <label for="showStep">Hide this section</label>
          </div>
          <div class="landing-page-steps-text color-2-77"
               v-if="!pageEditMode"
               v-html="decodeHtml(content.stepSection.description)"></div>
          <textarea class="landing-page-steps-text color-2-77"
                    data-gramm_editor="false"
                    placeholder="Section description"
                    data-lpignore="true"
                    v-if="pageEditMode && isGM()"
                    rows="1"
                    v-model="content.stepSection.description"
                    v-on:keydown="autoSize($event)">{{ decodeHtml(content.stepSection.description) }}</textarea>
          <div class="landing-page-steps-wrapper" ref="steps">
            <div class="step-item"
                 :class="[{ 'step-active': stepActive === (index + 1) }, 'step__' + step.id]"
                 v-for="(step, index) in content.stepSection.steps">
              <div class="step-item-content" v-if="!pageEditMode">
                {{ step.text }}
              </div>
              <textarea class="step-item-content"
                        data-gramm_editor="false"
                        data-lpignore="true"
                        placeholder="Step item text"
                        v-if="pageEditMode && isGM()"
                        rows="1"
                        v-model="step.text"
                        v-on:keydown="autoSize($event)">{{ step.text }}</textarea>
              <div class="step-item-image"
                   @click.prevent.stop="activatePopup(step)"
                   :title="step.altImage"
                   v-bind:style="{ backgroundImage: getImage(getHighImage(step)) }">
                <span class="step-item-upload" v-if="pageEditMode && isGM()"></span>
              </div>
            </div>
            <div class="landing-page-steps-pagination" v-if="getDeviceType('mobile')">
              <span class="step-item__1"
                    :class="[{ 'active': stepActive === 1 }]" @click.prevent="stepActive = 1"></span>
              <span class="step-item__2"
                    :class="[{ 'active': stepActive === 2 }]" @click.prevent="stepActive = 2"></span>
              <span class="step-item__3"
                    :class="[{ 'active': stepActive === 3 }]" @click.prevent="stepActive = 3"></span>
            </div>
          </div>
        </div>
      </div>
      <div class="landing-page-wrapper features-section landing-page-wrapper-gray"
           v-show="!content.featuresSection.hideSection || content.featuresSection.hideSection === 'null' || (pageEditMode && isGM())">
        <div class="landing-page-content">
          <div class="toggle-section-visibility"
               style="top: 20px;"
               v-if="pageEditMode && isGM()">
            <input type="checkbox"
                   class="form-control__checkbox"
                   id="showFeatures"
                   v-model="content.featuresSection.hideSection" />
            <label :for="'showFeatures'">Hide this section</label>
          </div>
          <h1 class="section-title center"
              v-html="content.featuresSection.title"
              v-if="!pageEditMode && content.featuresSection.title"></h1>
          <textarea class="section-title center"
                    v-if="pageEditMode && isGM()"
                    data-gramm_editor="false"
                    placeholder="Section title"
                    data-lpignore="true"
                    rows="1"
                    v-model="content.featuresSection.title"
                    v-on:keydown="autoSize($event)">{{ content.featuresSection.title }}</textarea>
          <div class="feature-list">
            <div class="feature-item"
                 :ref="'feature-' + index"
                 v-if="index < ppp"
                 :class="[{ 'expanded': item.expanded && !pageEditMode }]"
                 v-for="(item, index) in content.featuresSection.items">
              <a class="feature-close border-1-50"
                 href="#"
                 @click.prevent="expandSection('feature-' + index, item)"
                 v-if="!pageEditMode && item.expanded"></a>
              <div class="feature-title color-1-100"
                   v-html="item.title"
                   v-if="!pageEditMode && getDeviceType('mobile')"></div>
              <textarea class="feature-title color-1-100"
                        v-if="pageEditMode && isGM() && getDeviceType('mobile')"
                        data-gramm_editor="false"
                        placeholder="Item title"
                        data-lpignore="true"
                        rows="1"
                        v-model="item.title"
                        v-on:keydown="autoSize($event)">{{ item.title }}</textarea>
              <div class="feature-image"
                   :title="item.altImage"
                   v-bind:style="{ backgroundImage: getImage(item.image) }">
                <input type="text"
                       placeholder="Alt image"
                       v-if="pageEditMode && isGM()"
                       class="landing-page-image-alt"
                       v-model="item.altImage" />
                <label :for="'feature-image-upload-' + index"
                       v-if="pageEditMode && isGM()"
                       class="landing-page-image-upload"></label>
                <input type="file"
                       v-if="pageEditMode && isGM()"
                       @change="onFileChange($event, item, 'image')"
                       :id="'feature-image-upload-' + index" />
              </div>
              <div class="feature-content">
                <div class="feature-title color-1-100"
                     v-html="item.title"
                     v-if="!pageEditMode && !getDeviceType('mobile')"></div>
                <textarea class="feature-title color-1-100"
                          v-if="pageEditMode && isGM() && !getDeviceType('mobile')"
                          data-gramm_editor="false"
                          placeholder="Item title"
                          data-lpignore="true"
                          rows="1"
                          v-model="item.title"
                          v-on:keydown="autoSize($event)">{{ item.title }}</textarea>
                <div class="feature-date"
                     v-if="!pageEditMode && item.date">Posted on {{ getCurrentDate(item.date) }}</div>
                <div class="feature-excerpt"
                     v-html="item.excerpt"
                     v-if="!pageEditMode"></div>
                <div class="feature-text background-1-50-before"
                     v-html="item.text"
                     v-if="!pageEditMode && item.expanded"></div>
                <a class="feature-link background-1-10 background-1-50-hover color-2-100 border-1-50"
                   href="#"
                   :class="[{'expanded': item.expanded}]"
                   @click.prevent="expandSection('feature-' + index, item)"
                   v-if="!pageEditMode && item.text && item.text !== ''">
                  <template v-if="item.expanded">Show less</template>
                  <template v-else>Show more</template>
                </a>
                <div class="feature-date"
                     v-if="pageEditMode && isGM()">
                  Posted on
                  <datepicker
                    :inline="false"
                    v-model="item.date"
                    :open-date="item.date"
                    :format="'dd MMMM yyyy'"
                  />
                </div>
                <textarea class="feature-excerpt"
                          v-if="pageEditMode && isGM()"
                          data-gramm_editor="false"
                          placeholder="Item excerpt"
                          data-lpignore="true"
                          rows="1"
                          v-model="item.excerpt"
                          v-on:keydown="autoSize($event)">{{ item.excerpt }}</textarea>
                <wysiwyg v-model="item.text"
                         class="feature-text edit-mode"
                         v-if="pageEditMode && isGM()" />
                <div class="landing-page-remove"
                     v-if="pageEditMode && isGM()"
                     @click.prevent="removeSection(content.featuresSection.items, index)"></div>
              </div>
              <div class="clearfix"></div>
            </div>
            <div class="landing-page-add-section"
                 @click.prevent="addSection('features')"
                 v-if="pageEditMode && isGM()">+ Add row</div>
            <div class="feature-list-more background-1-10 background-1-50-hover color-2-100">
              <a href="#"
                 @click.prevent="ppp += 5"
                 v-if="content.featuresSection.items && ppp < content.featuresSection.items.length">
                Load more news
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="landing-page-wrapper clients-section"
           v-show="!content.clientSection.hideSection || content.clientSection.hideSection === 'null' || (pageEditMode && isGM())">
        <div class="landing-page-content">
          <div class="toggle-section-visibility"
               style="top: 20px;"
               v-if="pageEditMode && isGM()">
            <input type="checkbox"
                   class="form-control__checkbox"
                   id="showClients"
                   v-model="content.clientSection.hideSection" />
            <label :for="'showClients'">Hide this section</label>
          </div>
          <div class="flex-section">
            <div class="left-section center background-1-100-before">
              <h1 class="section-title text-left"
                  v-html="content.clientSection.title"
                  v-if="!pageEditMode"></h1>
              <textarea class="section-title text-left"
                        v-if="pageEditMode && isGM()"
                        data-gramm_editor="false"
                        placeholder="Section title"
                        data-lpignore="true"
                        rows="1"
                        v-model="content.clientSection.title"
                        v-on:keydown="autoSize($event)">{{ content.clientSection.title }}</textarea>
              <div class="section-description text-left"
                   v-html="content.clientSection.description"
                   v-if="!pageEditMode && getDeviceType('desktop')"></div>
              <textarea class="section-description text-left"
                        v-if="pageEditMode && isGM() && getDeviceType('desktop')"
                        data-gramm_editor="false"
                        placeholder="Section description"
                        data-lpignore="true"
                        rows="1"
                        v-model="content.clientSection.description"
                        v-on:keydown="autoSize($event)">{{ content.clientSection.description }}</textarea>
              <div class="section-buttons text-left">
                <a :href="content.clientSection.button.url"
                   class="section-action background-1-10 background-1-50-hover color-2-100"
                   v-if="!pageEditMode && content.clientSection.button.text !== '' && getDeviceType('desktop')">{{ content.clientSection.button.text }}</a>
              </div>
              <input class="landing-page-button-edit center"
                     v-if="pageEditMode && isGM() && getDeviceType('desktop')"
                     data-gramm_editor="false"
                     placeholder="Button text"
                     data-lpignore="true"
                     rows="1"
                     v-model="content.clientSection.button.text" />
              <input class="landing-page-button-edit center"
                     v-if="pageEditMode && isGM() && getDeviceType('desktop')"
                     data-gramm_editor="false"
                     placeholder="Button url"
                     data-lpignore="true"
                     rows="1"
                     v-model="content.clientSection.button.url" />
            </div>
            <div class="right-section" v-if="pageEditMode || content.clientSection.logos.length">
              <div class="logos flex-section">
                <slick class="clients-slider"
                       v-if="slidesReady"
                       ref="slick"
                       :options="slickOptions">
                  <a v-for="item in content.clientSection.logos"
                     :href="item.url">
                    <img :src="getImageFullPath(item.image)"
                         :alt="item.altImage">
                  </a>
                </slick>
                <div class="landing-page-slider-change"
                     @click.prevent.stop="switchSliderModal()"
                     v-if="pageEditMode"></div>
              </div>
            </div>
            <div class="mobile-left-section center background-1-100-before">
              <div class="section-description"
                   v-html="content.clientSection.description"
                   v-if="!pageEditMode && !getDeviceType('desktop')"></div>
              <textarea class="section-description center"
                        v-if="pageEditMode && isGM() && !getDeviceType('desktop')"
                        data-gramm_editor="false"
                        placeholder="Section description"
                        data-lpignore="true"
                        rows="1"
                        v-model="content.clientSection.description"
                        v-on:keydown="autoSize($event)">{{ content.clientSection.description }}</textarea>
              <a :href="content.clientSection.button.url"
                 class="section-action"
                 v-if="!pageEditMode && content.clientSection.button.text !== '' && !getDeviceType('desktop')">{{ content.clientSection.button.text }}</a>
              <input class="landing-page-button-edit center"
                     v-if="pageEditMode && isGM() && !getDeviceType('desktop')"
                     data-gramm_editor="false"
                     placeholder="Button text"
                     data-lpignore="true"
                     rows="1"
                     v-model="content.clientSection.button.text" />
              <input class="landing-page-button-edit center"
                     v-if="pageEditMode && isGM() && !getDeviceType('desktop')"
                     data-gramm_editor="false"
                     placeholder="Button url"
                     data-lpignore="true"
                     rows="1"
                     v-model="content.clientSection.button.url" />
            </div>
          </div>
        </div>
      </div>
      <div class="landing-page-change-image" v-if="activePopup && pageEditMode && isGM()">
        <div class="modal-inner" ref="iconPopup">
          <h1>Upload icons for: {{ activePopup.title }}</h1>
          <a href="#" class="modal-close" @click.prevent="closePopup()"></a>
          <div class="modal-item">
            <h2>Image (normal)</h2>
            <div class="modal-image"
                 v-bind:style="{ backgroundImage: getImage(activePopup.image) }">
              <label for="popup-step-image-upload"
                     class="step-item-upload"></label>
              <input type="file"
                     @change="onFileChange($event, activePopup, 'image')"
                     id="popup-step-image-upload" />
            </div>
            <input type="text" v-model="activePopup.altImage" placeholder="Image alt" />
          </div>
          <div class="modal-item">
            <h2>Image (high contrast)</h2>
            <div class="modal-image"
                 v-bind:style="{ backgroundImage: getImage(activePopup.imageHigh) }">
              <label for="popup-step-high-image-upload"
                     class="step-item-upload"></label>
              <input type="file"
                     @change="onFileChange($event, activePopup, 'imageHigh')"
                     id="popup-step-high-image-upload" />
            </div>
            <input type="text" v-model="activePopup.altImageHigh" placeholder="High contrast image alt" />
          </div>
          <div class="clearfix"></div>
        </div>
      </div>
      <div class="landing-page-change-image" v-if="sliderModalShown && pageEditMode && isGM()">
        <div class="modal-inner" ref="sliderPopup">
          <h1>Change slider items</h1>
          <a href="#" class="modal-close" @click.prevent="closePopup()"></a>
          <div class="logos">
            <div class="logo-item" v-for="(item, index) in content.clientSection.logos">
              <div class="modal-item">
                <h2>Image (normal)</h2>
                <div class="modal-image"
                     v-bind:style="{ backgroundImage: getImage(item.image) }">
                  <label :for="'logo-normal-' + index"
                         class="step-item-upload"></label>
                  <input type="file"
                         @change="onFileChange($event, item, 'image')"
                         :id="'logo-normal-' + index" />
                </div>
                <input type="text" v-model="item.altImage" placeholder="Image alt" />
              </div>
              <div class="modal-item">
                <h2>Image (high contrast)</h2>
                <div class="modal-image"
                     v-bind:style="{ backgroundImage: getImage(item.imageHigh) }">
                  <label :for="'logo-high-' + index"
                         class="step-item-upload"></label>
                  <input type="file"
                         @change="onFileChange($event, item, 'imageHigh')"
                         :id="'logo-high-' + index" />
                </div>
                <input type="text" v-model="item.altImageHigh" placeholder="High contrast image alt" />
              </div>
              <div class="logo-url">
                <input placeholder="url" v-model="item.url" />
              </div>
              <div class="landing-page-remove"
                   v-if="pageEditMode && isGM()"
                   @click.prevent="removeSection(content.clientSection.logos, index)"></div>
            </div>
            <div class="landing-page-add-section"
                 @click.prevent="addSection('logos')"
                 v-if="pageEditMode && isGM()">+ Add row</div>
          </div>
          <div class="clearfix"></div>
        </div>
      </div>
      <div class="landing-page-change-image" v-if="pageMetaEdit && isGM()">
        <div class="modal-inner" ref="metaEditPopup">
          <h1>Change page meta</h1>
          <a href="#" class="modal-close" @click.prevent="closePopup()"></a>
          <div class="popup-footer-edit">
            <div>
              <div class="meta-description">
                <label for="meta-title">Title</label>
                <input id="meta-title"
                       placeholder="Page meta title"
                       v-model="metaData.title" />
              </div>
              <div class="meta-description">
                <label for="meta-description">Description</label>
                <textarea id="meta-description"
                          placeholder="Page meta description"
                          v-model="metaData.description">{{ metaData.description }}</textarea>
              </div>
            </div>
          </div>
          <div class="popup-actions">
            <a href="#" @click.prevent="closePopup()" class="discard">Discard</a>
            <a href="#" @click.prevent="updateMeta()" class="submit">Save</a>
          </div>
        </div>
      </div>
      <div class="landing-page-change-image" v-if="logoEdit && isGM()">
        <div class="modal-inner" ref="logoEditPopup">
          <h1>Change page logo</h1>
          <a href="#" class="modal-close" @click.prevent="closePopup()"></a>
          <div class="popup-footer-edit">
            <div>
              <div class="modal-item">
                <div class="modal-image"
                     v-bind:style="{ backgroundImage: getImage(landing.logo) }">
                  <label for="page-logo"
                         class="step-item-upload"></label>
                  <input type="file"
                         id="page-logo"
                         @change="onFileChange($event, landing, 'logo')" />
                </div>
              </div>
            </div>
          </div>
          <div class="popup-actions">
            <a href="#" @click.prevent="closePopup()" class="discard">Discard</a>
            <a href="#" @click.prevent="updateLandingPage()" class="submit">Save</a>
          </div>
        </div>
      </div>
      <div class="landing-page-change-image" v-if="footerEdit && isGM()">
        <div class="modal-inner" ref="footerEditPopup">
          <h1>Change footer logos</h1>
          <a href="#" class="modal-close" @click.prevent="closePopup()"></a>
          <div class="popup-footer-edit">
            <div class="footerLogos">
              <div>
                <label for="logosLabel">Footer logos label</label><br />
                <input id="logosLabel"
                       v-model="content.footerData.logosLabel" />
              </div><br />
              <div class="repeater-item" v-for="(item, index) in content.footerData.logos">
                <div class="flex-section">
                  <div class="modal-item">
                    <div class="modal-image"
                         v-bind:style="{ backgroundImage: getImage(item.image) }">
                      <label :for="'logo-normal-' + index"
                             class="step-item-upload"></label>
                      <input type="file"
                             @change="onFileChange($event, item, 'image')"
                             :id="'logo-normal-' + index" />
                    </div>
                  </div>
                  <div class="modal-item">
                    <div class="modal-image"
                         v-bind:style="{ backgroundImage: getImage(item.imageHigh) }">
                      <label :for="'logo-high-' + index"
                             class="step-item-upload"></label>
                      <input type="file"
                             @change="onFileChange($event, item, 'imageHigh')"
                             :id="'logo-high-' + index" />
                    </div>
                  </div>
                  <input type="text"
                         v-model="item.url"
                         placeholder="Link" />
                  <input type="text"
                         v-model="item.altImage"
                         placeholder="Image alt" />
                </div>
                <div class="landing-page-remove"
                     @click.prevent="removeSection(content.footerData.logos, index)"></div>
              </div>
              <div class="landing-page-add-section"
                   @click.prevent="addSection('footer-logos')">+ Add logos</div>
            </div>
          </div>
          <div class="popup-actions">
            <a href="#" @click.prevent="closePopup()" class="discard">Discard</a>
            <a href="#" @click.prevent="updateLandingPage()" class="submit">Save</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import api from '@/api'
  import Slick from 'vue-slick'

  export default {
    name: 'company-registration-landing',
    data () {
      return {
        industryLanding: null,
        pageEditMode: false,
        landingPanel: false,
        logoEdit: false,
        pageMetaEdit: false,
        editHistory: false,
        pageVersions: [],
        metaData: {
          title: '',
          description: ''
        },
        landing: {
          logo: null
        },
        content: {
          title: '',
          description: '',
          heroSection: {
            title: '',
            description: '',
            altImage: '',
            image: '',
            hideSection: false
          },
          stepSection: {
            description: '',
            steps: [
              {
                id: 1,
                text: '',
                altImage: '',
                image: '',
                altImageHigh: '',
                imageHigh: ''
              },
              {
                id: 2,
                text: '',
                altImage: '',
                image: '',
                altImageHigh: '',
                imageHigh: ''
              },
              {
                id: 3,
                text: '',
                altImage: '',
                image: '',
                altImageHigh: '',
                imageHigh: ''
              }
            ],
            hideSection: false
          },
          clientSection: {
            title: '',
            description: '',
            button: {
              text: '',
              url: ''
            },
            logos: [
              {
                image: '',
                altImage: '',
                imageHigh: '',
                altImageHigh: '',
                url: ''
              }
            ],
            hideSection: false
          },
          featuresSection: {
            title: '',
            items: [
              {
                title: '',
                excerpt: '',
                text: '',
                date: null,
                image: '',
                altImage: '',
                expanded: false
              }
            ],
            hideSection: false
          },
          footerData: {
            logosLabel: '',
            logos: [
              {
                image: '',
                altImage: '',
                imageHigh: '',
                altImageHigh: '',
                url: ''
              }
            ],
            hideSection: false
          }
        },
        initialContent: {
          heroSection: {
            title: '',
            description: '',
            altImage: '',
            image: ''
          },
          clientSection: {
            title: '',
            description: '',
            button: {
              text: '',
              url: ''
            },
            logos: []
          },
          featuresSection: {
            title: '',
            items: []
          }
        },
        windowWidth: window.innerWidth,
        serverValidation: {
          errors: []
        },
        disableAPI: false,
        slidesReady: false,
        slickOptions: {
          arrows: false,
          dots: true,
          autoplay: true,
          autoplaySpeed: 5000,
          infinite: true,
          speed: 300,
          slidesToShow: 4,
          slidesToScroll: 4
        },
        slickOptionsContent: {
          arrows: false,
          dots: true,
          infinite: true,
          speed: 300,
          slidesToShow: 1,
          slidesToScroll: 1
        },
        activePopup: null,
        stepImageChange: false,
        stepActive: 1,
        xDown: null,
        yDown: null,
        sliderModalShown: false,
        registrationForm: {
          firstName: '',
          lastName: '',
          email: '',
          phone: '',
          function: '',
          title: '',
          registrationInProgress: false,
          registrationErrors: null,
          registrationFormSubmitted: false,
          registrationFormResponseCode: 1
        },
        ppp: 5,
        footerEdit: false,
        focus: null,
        companyUrl: null,
        confOpened: null
      }
    },
    computed: {
      ...mapGetters([
        'getIsLoggedIn',
        'getUserRole',
        'selectedHightCont',
        'getSelectedFontSize',
        'getConfData'
      ])
    },
    methods: {
      ...mapActions([
        'clearConfAction',
        'initConfAction',
        'redirect',
        'getRoles',
        'setFontSizeActive',
        'setColorPaletteActive'
      ]),
      decodeHtml (value) {
        var txt = document.createElement('textarea')
        txt.innerHTML = value
        return txt.value
      },

      handleTouchStart (evt) {
        this.xDown = evt.touches[0].clientX
        this.yDown = evt.touches[0].clientY
      },
      handleTouchMove (evt) {
        if (!this.xDown || !this.yDown) {
          return
        }
        if (!this.getDeviceType('mobile')) {
          return
        }
        let target = evt.target
        let steps = this.$refs.steps
        if (steps && steps !== target && steps.contains(target)) {
          let xUp = evt.touches[0].clientX
          let yUp = evt.touches[0].clientY
          let xDiff = this.xDown - xUp
          let yDiff = this.yDown - yUp
          if (Math.abs(xDiff) > Math.abs(yDiff)) {
            if (xDiff > 0) {
              if (this.stepActive === 1) {
                this.stepActive = 3
              } else {
                this.stepActive -= 1
              }
            } else {
              if (this.stepActive === 3) {
                this.stepActive = 1
              } else {
                this.stepActive += 1
              }
            }
          }
          this.xDown = null
          this.yDown = null
        }
      },
      updateLandingPage () {
        if (this.disableAPI) return
        this.logoEdit = false
        this.footerEdit = false
        let body = JSON.stringify(this.content)
        let pageData = {
          slug: this.industryLanding,
          body: body,
          registrationLanding: true,
          logo: this.landing.logo
        }
        this.disableAPI = true
        this.$http.post(api.URLS.staticpage, pageData, api.headersAuthSettings).then((res) => {
          this.disableAPI = false
          this.landingPanel = false
          this.getLandingPage(null, true)
        }).catch((err) => {
          this.disableAPI = false
          console.log('err', err)
        })
      },
      updateMeta () {
        if (this.disableAPI) return
        let metaTitle = this.metaData.title
        let metaDescription = this.metaData.description
        let pageData = {
          title: metaTitle,
          slug: this.industryLanding,
          description: metaDescription
        }
        this.disableAPI = true
        this.$http.post(api.URLS.staticpage, pageData, api.headersAuthSettings).then((res) => {
          this.disableAPI = false
          document.location.reload()
        }).catch((err) => {
          this.disableAPI = false
          console.log('err', err)
        })
      },
      getPageVersions () {
        let self = this
        if (this.disableAPI) return
        this.disableAPI = true
        this.$http.get(api.URLS.staticpagechanges + '/' + this.industryLanding + '?type=2', api.headersAuthSettings).then((res) => {
          this.disableAPI = false
          this.pageVersions = []
          for (let index in res.body) {
            self.pageVersions.push({
              label: self.convertDateTime(res.body[index].createdAt),
              id: res.body[index].id,
              value: res.body[index].id
            })
          }
          this.editHistory = true
        }).catch((err) => {
          this.disableAPI = false
          console.log('err', err)
        })
      },
      getPageVersionsForSelect () {
        return this.pageVersions
      },
      changeLandingPage (el) {
        this.getLandingPage(el.id)
      },
      convertDateTime (payload) {
        if (!payload) return
        let date = new Date(payload)
        let fullYear = date.getFullYear()
        let month = date.getMonth() + 1
        let day = date.getDate()
        let hours = date.getHours()
        let minutes = date.getMinutes()
        let ampm = hours >= 12 ? 'PM' : 'AM'
        let newHours = hours % 12 ? hours % 12 : 12
        function toDoubleDigit (num) {
          return num.toString().length < 2 ? '0' + num : num.toString()
        }
        let dateString = toDoubleDigit(day) + '/' + toDoubleDigit(month) + '/' + fullYear
        let timeString = toDoubleDigit(newHours) + ':' + toDoubleDigit(minutes) + ' ' + ampm
        return dateString + ' ' + timeString
      },
      expandSection (section, feature) {
        feature.expanded = !feature.expanded
        this.goToPageSection(section)
      },
      goToPageSection (ref) {
        let element = this.$refs[ref]
        if (element) {
          let here = element[0] ? element[0] : element
          here.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          })
        }
      },
      getLandingPage (id, refresh) {
        this.slidesReady = false
        let body = {
          slug: this.industryLanding,
          type: 2
        }
        if (id) {
          body.id = id
        }
        this.$http.post(api.URLS.staticpage + '/' + this.industryLanding, body, api.headersAuthSettings).then((res) => {
          this.disableAPI = false
          let pageData = JSON.parse(res.data.body)
          if (pageData.footerData) {
            this.content.footerData = pageData.footerData
          }
          if (pageData.heroSection) {
            this.content.heroSection = pageData.heroSection
          }
          if (pageData.stepSection) {
            this.content.stepSection = pageData.stepSection
          }
          if (pageData.featuresSection) {
            this.content.featuresSection = pageData.featuresSection
          }
          if (pageData.clientSection) {
            this.content.clientSection = pageData.clientSection
          }
          if (res.data.logo) {
            this.landing.logo = res.data.logo
          }
          this.metaData.title = res.data.title
          this.metaData.description = res.data.description
          if (this.metaData.title && this.metaData.title !== '') {
            document.title = this.metaData.title
          }
          this.addPageMeta('description', [{name: 'content', value: this.metaData.description}])
          this.content.title = this.metaData.title
          this.content.description = this.metaData.description
          // Set initial data
          this.initialContent = pageData
          this.slidesReady = true
          this.$nextTick(() => {
            if (this.$refs.slick) {
              this.$refs.slick.reSlick()
            }
          })
          if (id) {
            this.pageEditSwitch()
          } else {
            if (refresh) {
              this.pageEditMode = false
            }
          }
          if (this.$route.name === 'edit-company-registration-landing') {
            this.$nextTick(() => {
              this.autoSizeOnInit()
            })
          }
          if (this.landing.logo) {
            let logoNode = document.getElementById('landingHeaderLogo')
            if (logoNode) {
              logoNode.src = this.getImageFullPath(this.landing.logo)
            }
          }
        }).catch((err) => {
          console.log('err', err)
        })
      },
      changeEmail () {
        this.registrationForm.registrationFormSubmitted = false
      },
      activateEditHistory () {
        this.getPageVersions()
      },
      addPageMeta (name, data) {
        let meta = document.createElement('meta')
        meta.name = name
        for (let index in data) {
          meta.setAttribute(data[index].name, data[index].value)
        }
        document.getElementsByTagName('head')[0].appendChild(meta)
      },
      discardChanges () {
        this.getLandingPage(null, true)
      },
      pageEditSwitch () {
        this.confOpened = 'edit'
        this.initConfAction({
          actionName: 'editLanding'
        })
      },
      pageEditSwitchConfirmed () {
        this.pageEditMode = true
        this.$nextTick(() => {
          this.autoSizeOnInit()
        })
        this.getConfData.actionConfirmed = false
      },
      discardPageEdit () {
        this.discardChanges()
        if (this.editHistory) {
          this.editHistory = false
        } else {
          this.landingPanel = false
        }
      },
      addSection (section) {
        if (section === 'features') {
          this.content.featuresSection.items.push({
            title: '',
            excerpt: '',
            text: '',
            date: new Date(),
            image: '',
            altImage: '',
            expanded: false
          })
        }
        if (section === 'logos') {
          this.content.clientSection.logos.push({
            image: '',
            altImage: '',
            imageHigh: '',
            altImageHigh: '',
            url: ''
          })
        }
        if (section === 'footer-logos') {
          this.content.footerData.logos.push({
            image: '',
            altImage: '',
            imageHigh: '',
            altImageHigh: '',
            url: ''
          })
        }
      },
      removeSection (section, index) {
        section.splice(index, 1)
      },
      onFileChange (e, target, item) {
        var input = e.target
        let self = this
        if (input.files && input.files[0] && input.files[0].name.match(/.(jpg|jpeg|png|gif|svg)$/i)) {
          var reader = new FileReader()
          reader.onload = function (e) {
            let fileName = input.files[0].name
            let extension = fileName.split('.').pop().toLowerCase()
            if (self.disableAPI) return
            let pageData = {
              file: e.target.result,
              extension: extension
            }
            self.disableAPI = true
            self.$http.post(api.URLS.uploadFile, pageData, api.headersAuthSettings).then((res) => {
              self.disableAPI = false
              target[item] = res.body
            }).catch((err) => {
              self.disableAPI = false
              console.log('err', err)
            })
          }
          reader.readAsDataURL(input.files[0])
        }
      },
      getImagePath () {
        return api.serverURL + '/uploads/images/content/'
      },
      isBase64 (payload) {
        if (!payload && payload !== '') {
          return true
        }
        return payload.indexOf('data:') !== -1
      },
      getImage (payload) {
        if (!payload) {
          return ''
        }
        return this.isBase64(payload) ? 'url(' + payload + ')' : 'url(' + this.getImagePath() + payload + ')'
      },
      getImageFullPath (payload) {
        if (!payload) {
          return ''
        }
        return this.isBase64(payload) ? payload : this.getImagePath() + payload
      },
      getCurrentDate (payload) {
        if (!payload) return
        let date = new Date(payload)
        let dd = date.getDate()
        let mm = date.getMonth()
        let yyyy = date.getFullYear()
        if (dd < 10) {
          dd = '0' + dd
        }

        var monthNames = ['January', 'February', 'March', 'April', 'May', 'June',
          'July', 'August', 'September', 'October', 'November', 'December'
        ]

        return dd + ' ' + monthNames[mm] + ' ' + yyyy
      },
      getHighImage (item) {
        return this.selectedHightCont === 1 ? item.imageHigh : item.image
      },
      getHighImageAlt (item) {
        return this.selectedHightCont === 1 ? item.altImageHigh : item.altImage
      },
      activatePopup (item) {
        this.activePopup = item
      },
      closePopup () {
        this.activePopup = null
        this.sliderModalShown = false
        this.slidesReady = true
        this.pageMetaEdit = false
        this.logoEdit = false
        this.footerEdit = false
        this.$nextTick(() => {
          this.$refs.slick.reSlick()
        })
      },
      closePopupOnOutsideClick (e) {
        let iconPopup = this.$refs.iconPopup
        let sliderPopup = this.$refs.sliderPopup
        let target = e.target
        if (iconPopup && iconPopup !== target && !iconPopup.contains(target)) {
          this.activePopup = null
        }
        if (sliderPopup && sliderPopup !== target && !sliderPopup.contains(target)) {
          this.switchSliderModal()
          this.slidesReady = true
          this.$nextTick(() => {
            this.$refs.slick.reSlick()
          })
        }
      },
      switchSliderModal () {
        this.sliderModalShown = !this.sliderModalShown
      },
      autoSize (el) {
        setTimeout(function () {
          el.target.style = 'height:auto; padding:0'
          el.target.style = 'height:' + el.target.scrollHeight + 'px'
        }, 0)
      },
      autoSizeOnInit () {
        let textAreas = document.getElementsByTagName('textarea')
        for (let i = 0; i < textAreas.length; i++) {
          let item = textAreas[i]
          setTimeout(function () {
            item.style = 'height:auto; padding:0'
            item.style = 'height:' + item.scrollHeight + 'px'
          }, 0)
        }
      },
      isGM () {
        let isLogged = this.getIsLoggedIn
        if (!isLogged) {
          return false
        }
        let userRole = this.getUserRole
        if (userRole === 'gm') {
          return true
        }
        return false
      },
      handleWindowResize (event) {
        this.windowWidth = event.currentTarget.innerWidth
      },
      getDeviceType (check) {
        let width = this.windowWidth
        let deviceName = ''
        if (width > 1024) {
          deviceName = 'desktop'
        } else if (width > 640) {
          deviceName = 'tablet'
        } else {
          deviceName = 'mobile'
        }
        return check === deviceName
      },
      editPageLogo () {
        this.logoEdit = true
      },
      submitForm (confirmEmailNotFound) {
        if (this.disableAPI) return
        this.$validator.validateAll()
        this.registrationForm.registrationInProgress = true
        let formData = {
          firstName: this.registrationForm.firstName,
          lastName: this.registrationForm.lastName,
          email: this.registrationForm.email,
          phone: this.registrationForm.phone,
          function: this.registrationForm.function,
          title: this.registrationForm.title,
          companyUrl: this.companyUrl
        }
        if (confirmEmailNotFound) {
          formData['confirmEmail'] = true
        }
        this.disableAPI = true
        this.$http.post(api.URLS.register, formData).then((res) => {
          this.disableAPI = false
          this.registrationForm.registrationFormSubmitted = true
          this.registrationForm.registrationInProgress = false
          this.registrationForm.registrationErrors = null
          this.registrationForm.registrationFormResponseCode = res.body.code
        }).catch((err) => {
          this.disableAPI = false
          this.registrationForm.registrationFormSubmitted = false
          this.registrationForm.registrationInProgress = false
          this.registrationForm.registrationErrors = []
          this.registrationForm.registrationFormResponseCode = err.body.code
          if (this.registrationForm.registrationFormResponseCode) {
            this.registrationForm.registrationErrors = [err.body.message]
          } else {
            for (let i = 0; i < err.body.length; i++) {
              this.registrationForm.registrationErrors.push(err.body[i])
            }
          }
        })
      },
      checkCompany () {
        let formData = {
          companyUrl: this.companyUrl
        }
        this.$http.post(`${api.URLS.companiesS}/check-company-url`, formData).then(() => {

        }).catch((err) => {
          if (err.status === 404) {
            let props = this.$router.resolve({
              name: 'error'
            })
            this.$router.push(props.href)
          }
        })
      }
    },
    mounted () {
      this.industryLanding = this.$route.params['industry']
      this.companyUrl = this.$route.params['company']
      if (this.$route.name !== 'edit-company-registration-landing' && this.companyUrl !== 'default') {
        this.checkCompany()
      }
      this.getLandingPage()
      this.setFontSizeActive()
      this.setColorPaletteActive()
      window.addEventListener('resize', this.handleWindowResize)
      document.addEventListener('click', this.closePopupOnOutsideClick)
      if (this.$route.name === 'edit-company-registration-landing') {
        this.pageEditMode = true
        this.landingPanel = true
      }
    },
    beforeDestroy () {
      window.removeEventListener('resize', this.handleWindowResize)
      document.addEventListener('click', this.closePopupOnOutsideClick)
    },
    components: {
      Slick
    },
    watch: {
      '$route' (to, from) {
        if (to.params.industry !== from.params.industry || to.params.company !== from.params.company) {
          this.industryLanding = to.params.industry
          this.companyUrl = to.params.company
          if (this.$route.name !== 'edit-company-registration-landing' && this.companyUrl !== 'default') {
            this.checkCompany()
          }
          this.getLandingPage()
        }
      },
      'getConfData.actionConfirmed' (value) {
        if (value) {
          if (this.confOpened === 'edit') this.pageEditSwitchConfirmed()
          this.clearConfAction()
        }
      }
    }
  }
</script>

<style src="@/assets/scss/main/company-landing.scss" lang="scss" scoped></style>
<style src="@/assets/scss/main/homepage.scss" lang="scss" scoped></style>
<style src="@/assets/scss/main/landing-page.scss" lang="scss" scoped></style>
<style src="@/assets/scss/components/slick.scss" lang="scss" scoped></style>

<style lang="scss" scoped>
  .inform-popup {
    margin-bottom: 0;
    margin-top: 0;
    position: relative;
    min-height: 60px;
    max-width: 90%;
  }
  .inform-message-inner {
    position: absolute;
    top: 10px;
    left: 0;
    z-index: 99999999;
    width: 100%;
  }
  .company-landing .landing-page-wrapper.hero-section .hero-login {
    margin-bottom: 30px;
  }
  .landing-page-wrapper.clients-section .left-section::before {
    left: 85px;
  }
</style>



// WEBPACK FOOTER //
// CompanyRegistrationLanding.vue?361c35fe